import { type Event } from "@package/ui-gql/index-analytics";
import { type SliceWallScreenState } from "@package/ui-wall-engine";
import { type WritableDraft } from "immer";
import { createContext, useContext } from "react";

export type TriviaHelp = "fityfity" | "poll" | "ai";

export type TriviaState = {
  analytics: Event[];
  analyticsLoading: boolean;
  availableTriviaHelp: TriviaHelp[];
  component: "question" | "answer" | "result";
  screen?: SliceWallScreenState;
  questionIndex: number;
  questionChoiceIndexes: number[];
  updateTriviaState: (
    callback: (draft: WritableDraft<TriviaState>) => void,
  ) => void;
};

export const defaultTriviaContextState: TriviaState = {
  analytics: [],
  analyticsLoading: false,
  availableTriviaHelp: ["fityfity", "poll"],
  component: "question",
  questionIndex: 0,
  questionChoiceIndexes: [],
  updateTriviaState: () => {},
};

export const TriviaContext = createContext<TriviaState>(
  defaultTriviaContextState,
);
export const useTriviaContext = () => useContext(TriviaContext);
